import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Reorders the direct child rows of the element by dragging a row's handle or
// pressing the arrow keys on it, and keeps each row's position field in sync.
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-sortable-rows-handle]",
      animation: 150,
      forceFallback: true,
      fallbackOnBody: true,
      onStart: () => document.addEventListener("pointermove", this.keepVertical),
      onEnd: () => document.removeEventListener("pointermove", this.keepVertical)
    })
    this.renumber()
    this.observer = new MutationObserver(() => this.renumber())
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer.disconnect()
    this.sortable.destroy()
    document.removeEventListener("pointermove", this.keepVertical)
  }

  // SortableJS has no axis lock, so drop the horizontal offset it gives the
  // copy that follows the pointer. It runs after SortableJS's own handler.
  keepVertical = () => {
    const preview = Sortable.ghost
    if (!preview?.style.transform) return

    const transform = new DOMMatrix(preview.style.transform)
    transform.e = 0
    preview.style.transform = transform.toString()
  }

  move(event) {
    const offset = { ArrowUp: -1, ArrowDown: 1 }[event.key]
    if (!offset) return

    event.preventDefault()
    const handle = event.currentTarget
    const rows = [...this.element.children].filter((row) => !row.hidden)
    const row = rows.find((row) => row.contains(handle))
    const neighbour = rows[rows.indexOf(row) + offset]
    if (!neighbour) return

    this.element.insertBefore(row, offset < 0 ? neighbour : neighbour.nextElementSibling)
    handle.focus()
  }

  renumber() {
    [...this.element.children].forEach((row, index) => {
      const field = row.querySelector("input[name$='[position]']")
      if (field) field.value = index
    })
  }
}
